<script setup>
import DashboardLayout from "@/layouts/DashboardLayout.vue";
</script>
<template>
  <DashboardLayout>
    <router-view></router-view>
  </DashboardLayout>
</template>
